import { render, staticRenderFns } from "./HddsTable.vue?vue&type=template&id=1cb23718"
import script from "./HddsTable.vue?vue&type=script&lang=ts"
export * from "./HddsTable.vue?vue&type=script&lang=ts"
import style0 from "./HddsTable.vue?vue&type=style&index=0&id=1cb23718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports